import { Button, css, styled } from "@mui/material";
import { ICustomerPortalTheme } from "@smartrr/shared/entities/CustomerPortalTheme";

/**
 * @todo: these types were in declared globally – moving here for now, will need to revisit
 * if ttere were side effect we ended up relying on, will also need to move these to dedicated files regardless
 */
interface BreakpointOverrides {
  xs: true;
  sm: true;
  md: true;
  lg: true;
  xl: true;
  mdsm: true; // adds the `mobile` breakpoint
}
interface Theme extends ICustomerPortalTheme {
  breakPoints?: BreakpointOverrides;
}

export const OTPContainer = styled("div")<{ shake: boolean; isMobile: boolean }>(
  ({ shake, isMobile }) => css`
    > * {
      animation: ${shake ? "1s shake" : "none"};
      animation-iteration-count: 1;
      gap: ${isMobile ? "1px" : "7px"};
    }

    @keyframes shake {
      0% {
        transform: translate(3px, 0px);
      }
      25% {
        transform: translate(-1px, 0px);
      }
      50% {
        transform: translate(2px, 0px);
      }
      100% {
        transform: translate(0px, 0px);
      }
    }
  `
);

export const LoginButton = styled(Button)<{ theme: Theme }>`
  --border-offset: 0 !important;
  --border-opacity: 0 !important;
  background-color: ${props => props.theme.modernPrimaryButtonColor} !important;
  border-color: ${props => props.theme.modernPrimaryButtonBorderColor}!important;
  border-radius: ${props => props.theme.modernButtonBorderRadius}px !important;
  border-style: solid !important;
  border-width: ${props => props.theme.modernButtonBorderWidth}px !important;
  box-shadow: none !important;
  color: ${props => props.theme.modernPrimaryButtonFontColor} !important;
  font-family: ${props => props.theme.modernButtonCTAFontFamily} !important;
  font-size: ${props => props.theme.modernButtonCTAFontSize}px !important;
  font-weight: ${props => props.theme.modernButtonCTAFontWeight} !important;
  height: 40px !important;
  letter-spacing: ${props => props.theme.modernButtonCTAFontLetterSpacing}px !important;
  line-height: ${props =>
    props.theme.modernButtonCTAFontLineHeight ? props.theme.modernButtonCTAFontLineHeight : "inherit"};
  margin: 0 !important;
  max-width: 360px;
  min-height: 40px !important;
  opacity: ${props => (props.disabled ? "40%" : "100%")};
  text-transform: initial;
  transition: 0.3s ease-in-out;

  &:hover {
    --border-offset: 0 !important;
    --border-opacity: 0 !important;
    box-shadow: ${props => props.theme.modernPrimaryButtonColor} 0px 0px 5px !important;

    ::after {
      --border-offset: 0 !important;
    }
  }

  width: 100%;
`;

export const AuthFlowContainerStyles = {
  maxWidth: "420px",
  minWidth: "335px",
  minHeight: "370px",

  margin: "auto",
  marginTop: "10vh",

  display: "flex",
  flexDirection: "column",
  alignItems: "center",

  gap: "30px",
  padding: "75px 30px",

  borderRadius: "25px",

  boxShadow: "none",

  textAlign: "center",
  justifyContent: "center",
};

export const emailTextFieldStyles = (theme: any, errorType?: any) => {
  return {
    width: "100%",
    maxWidth: "360px",
    backgroundColor: "transparent",
    borderRadius: `${theme.modernButtonBorderRadius || 25}px`,
    textAlign: "center",
    color: `${theme.modernSecondaryButtonFontColor || "#202223"} !important`,

    boxShadow:
      errorType === "no_email"
        ? "0px 0px 5px #ff00007f, inset 0px 0px 4px #D6D6D6;"
        : "0px 0px 4px 0px #D6D6D6 inset",

    "*": {
      borderRadius: `${theme.modernButtonBorderRadius || 25}px`,
    },

    "> .MuiOutlinedInput-root": {
      height: "40px",
      boxShadow: "none",
      borderRadius: `${theme.modernButtonBorderRadius || 25}px`,
      ":hover fieldset": {
        borderColor: "#0000003b",
      },
      "&.Mui-focused fieldset": {
        boxShadow: "inset 0px 0px 4px #0066ff7f",
        border: "none",
      },
    },

    "> * > input": {
      fontWeight: 400,
      fontSize: "16px",
      lineHeight: "19px",
      textAlign: "center",
      color: `${theme.modernSecondaryButtonFontColor || "#202223"} !important`,

      ":-webkit-autofil, :-webkit-autofill:hover, :-webkit-autofill:focus, :-webkit-autofill:active": {
        WebkitBoxShadow: "0 0 0 60px #fafafa inset !important",
        backgroundColor: "#fafafa !important",
        backgroundClip: "content-box !important",
      },

      ":focus-visible": {
        boxShadow: "none",
      },
    },
  };
};

export const footerTypographyStyles = (checkIfEmailError: any, errorType: any) => {
  return {
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "16px",
    color: checkIfEmailError(errorType) || errorType === "server_error" ? "#C61E00" : "#202223",
  };
};
export const footerTypographyLinkWrapperStyles = (errorType: any) => {
  return {
    height: "16px",
    textDecoration: "underline",
    textTransform: "initial",
    color: errorType === "wrong_email" ? "#C61E00" : "#202223",

    "> span": {
      color: errorType === "wrong_email" ? "#C61E00" : "#202223",
    },

    ":hover": {
      cursor: "pointer",
    },
  };
};

export const OtpInputStyles = (userPassedOTP: any, isMobile: any) => {
  return {
    width: "40px",
    height: "40px",
    borderRadius: "15px",
    fontSize: "16px",
    outline: "none",
    border: isMobile ? "1px solid #D6D6D6" : "none",
    boxShadow: userPassedOTP ? "0px 0px 5px #00f0607f, inset 0px 0px 3px #D6D6D6" : "inset 0px 0px 3px #D6D6D6",
  };
};

export const OtpInputErrorStyles = () => {
  return { boxShadow: " 0px 0px 5px #ff00007f, inset 0px 0px 3.01316px #D6D6D6" };
};

export const OtpInputFocusStyles = (userPassedOTP: any, isMobile: any) => {
  return {
    border: isMobile ? "1px solid #0066ff7f" : "none",
    boxShadow: "0px 0px 5px #0066ff7f, inset 0px 0px 3px #D6D6D6",
  };
};

export const HelpErrorTextStyles = {
  height: "16px",
  textDecoration: "underline",
  textTransform: "initial",
  color: "#202223",
  fontSize: "12px",
  ":hover": {
    cursor: "pointer",
  },
};
